/**
 * One-time promise that resolves when Supabase's initial auth check completes.
 *
 * Use in TanStack Router's `beforeLoad` to safely read the session:
 *   await sessionReady;
 *   const session = getSessionSnapshot();
 */

import { getSessionSnapshot, subscribeSession } from "@lato/client/lib/supabase";

export const sessionReady = new Promise<void>((resolve) => {
  if (getSessionSnapshot() !== undefined) {
    resolve();
    return;
  }
  const unsub = subscribeSession(() => {
    resolve();
    unsub();
  });
});
